import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore"
import { Account } from "../Type"

export const getAccountFromDocSnapshot = (
  accountAnonymous: string,
  doc: QueryDocumentSnapshot<DocumentData, DocumentData>
): Account => {
  return {
    id: doc.id,
    name: doc.data().name === "" ? accountAnonymous : doc.data().name,
    insertDate: doc.data().insertDate,
    lastEditDate: doc.data().lastEditDate,
  }
}
